// Vuex

import Request from './request';

// 获取用户信息
async function getUserInfo() {
    return Request('get', 'api/shop-users/get-user-info')
}

// 修改用户信息
async function edit(data) {
    return Request('post', 'api/shop-users/edit', data)
}


export default {
    getUserInfo,
    edit,
}
